import React from "react";
import {
  Box,
  Heading,
  Text,
  List,
  ListItem,
  ListIcon,
  UnorderedList,
  Link,
} from "@chakra-ui/react";
import { CheckCircleIcon } from "@chakra-ui/icons";

const About = () => {
  return (
    <Box p={8}>
      <Heading as="h1" size="xl">
        About
      </Heading>
      <Text my={4}>This website is one of my portfolio</Text>
      <Text>Technologies used:</Text>
      <UnorderedList>
        <List spacing={3}>
          <ListItem>
            <ListIcon as={CheckCircleIcon} color="green.500" />
            React JS
          </ListItem>
          <ListItem>
            <ListIcon as={CheckCircleIcon} color="green.500" />
            JSON API
          </ListItem>
          <ListItem>
            <ListIcon as={CheckCircleIcon} color="green.500" />
            Version Control System
          </ListItem>
        </List>
      </UnorderedList>
      <Text my={4}>
        Contact me through{" "}
        <Link
          href="https://www.linkedin.com/in/wildan-hakim-578544136/"
          isExternal
        >
          LinkedIn,
        </Link>{" "}
        <Link
          href="https://www.upwork.com/freelancers/~01e64c01ebdbb0aece"
          isExternal
        >
          Upwork,
        </Link>{" "}
        <Link href="mailto:wildanhakim98@gmail.com" isExternal>
          send me an email.
        </Link>
      </Text>
    </Box>
  );
};

export default About;
